module.exports = __webpack_public_path__ + "img/1241712134.72453616.jpg";